import clientAPI from "@/api/ClientAPIMixin.js";
//import Vue from "vue"

export const JobUpdater = {
  namespaced: true,

  state: {
    UpdateOrderTrigger: 0,
    UpdateTotalsTrigger: 0,
  },

  mutations: {
    INCREMENT_UPADTE_ORDER_TRIGGER(state) {
      state.UpdateOrderTrigger++;
    },

    INCREMENT_UPADTE_TOTALS_TRIGGER(state) {
      state.UpdateTotalsTrigger++;
    },
  },

  actions: {
    async UpdateEntireJob({ dispatch }, JobData) {
      //Update job details
      dispatch("UpdateJobDetails", JobData);

      //Update customer
      dispatch("UpdateCustomer", JobData.Customer);

      //Update address
      var address;
      if ( //if no adress fields are populated
        !JobData.DeliveryAddress ||
        !JobData.DeliveryAddress.Name &&
        !JobData.DeliveryAddress.Country &&
        !JobData.DeliveryAddress.Zip &&
        !JobData.DeliveryAddress.City &&
        !JobData.DeliveryAddress.Street
      ) {
        address = null;
      } else {
        address = JobData.DeliveryAddress;
        if (address.Id === null) {
          address.archived = true;
        }
      }
      dispatch("UpdateCustomerAddress", address);

      //Update contact
      dispatch("UpdateCustomerContact", JobData.CustomerPerson);

      //Update subjobs
      if (JobData.InverseParent && JobData.InverseParent.length > 0) {
        JobData.InverseParent.forEach((child) => {
          
          
          if (child.JobStatusId != 110) {
            dispatch("UpdateSubjob", child);
          }
        });
      }
      else {
        dispatch("JobHub/JobSubjobs/clearSubjobs", [], { root: true });
      }
    },

    UpdateCustomer({ dispatch }, UpdatedCustomer) {
      dispatch('JobHub/JobCustomer/setCustomer', UpdatedCustomer, { root: true });
    },

    UpdateCustomerAddress({ dispatch }, UpdatedAddress) {
      dispatch('JobHub/JobCustomer/setDeliveryAdress', UpdatedAddress, { root: true });
    },

    UpdateCustomerContact({ dispatch }, UpdatedContact) {
      dispatch("JobHub/JobCustomer/setCustomerContact", UpdatedContact, { root: true });
    },

    UpdateJobDetails({ dispatch }, UpdatedDetails) {
      dispatch("JobHub/JobParentjob/setJobDetails", UpdatedDetails, { root: true });
    },

    UpdateSubjobs({ dispatch }, UpdatedSubjobs) {
      dispatch("JobHub/JobSubjobs/setSubjobs", UpdatedSubjobs, { root: true });
    },

    UpdateSubjob({ dispatch }, Subjob) {
      dispatch("JobHub/JobSubjobs/replaceSubjob", Subjob, { root: true });
    },

    AutoUpdateSubjob({ dispatch }, SubjobId) {
      dispatch("JobHub/JobSubjobs/getSubjob", SubjobId, { root: true });
    },

    UpdateOrderTotals({ dispatch }, SubjobId) {
      dispatch("JobHub/JobSubjobs/getSubjob", SubjobId, { root: true });
    },



    triggerUpdateCompleteOrder({ commit }) {
      commit("INCREMENT_UPADTE_ORDER_TRIGGER");
    },

    AutoUpdateCompleteOrder({ dispatch, rootGetters }) {
      const jobId = (rootGetters['JobHub/JobDetails']).Id;
      
      clientAPI.methods.getJobOrder(jobId)
        .then(async (response) => {
          
          response.InverseParent.forEach((subjoborder) => {
            const machineJobNoInvoiceupdate = { id: subjoborder.JobId, key: "NoInvoice", value: subjoborder.NoInvoice };
            const update = { id: subjoborder.JobId, key: "Order", value: subjoborder };
            
            dispatch("JobHub/JobSubjobs/setSubjobDetail", machineJobNoInvoiceupdate, { root: true });
            dispatch("JobHub/JobSubjobs/setSubjobDetail", update, { root: true });
          });
          delete response.InverseParent;

          dispatch("JobHub/JobParentjob/setJobOrder", response, { root: true });
        })
        .catch(() => { })
        .finally(() => { });
    },



    triggerUpdateOrderTotals({ commit }) {
      commit("INCREMENT_UPADTE_TOTALS_TRIGGER");
    },

    AutoUpdateOrderTotals({ dispatch, rootGetters }) {
      const jobId = (rootGetters['JobHub/JobDetails']).Id;
      
      clientAPI.methods.getOrderTotalByOrderId(jobId)
        .then((response) => {
          
          const discountUpdate = { key: "TotalDiscount", value: response.TotalDiscount };
          const sumUpdate = { key: "TotalAmountExclVat", value: response.TotalAmountExclVat };
          
          
          dispatch("JobHub/JobParentjob/setJobOrderField", discountUpdate, { root: true });
          dispatch("JobHub/JobParentjob/setJobOrderField", sumUpdate, { root: true });

          response.InverseParent.forEach((subjoborder) => {
            const discountUpdate = { id: subjoborder.JobId, key: "Order.TotalDiscount", value: subjoborder.TotalDiscount };
            const sumUpdate = { id: subjoborder.JobId, key: "Order.TotalAmountExclVat", value: subjoborder.TotalAmountExclVat };
            
            
            dispatch("JobHub/JobSubjobs/setSubjobDetail", discountUpdate, { root: true });
            dispatch("JobHub/JobSubjobs/setSubjobDetail", sumUpdate, { root: true });
          });
        })
        .catch(() => { })
        .finally(() => { });
    },
  },

  getters: {

  },
};
